const getPageUrl = () => {
  if (typeof window === 'undefined') return '';

  return window.location.origin + window.location.pathname;
};

const DEBUG_FLAG = 'debugAnalytics';

// Флаг разбираем один раз при загрузке страницы:
// - ?debugAnalytics=1 — включает и сохраняет в localStorage (query-параметр
//   умирает после первого SPA-перехода, localStorage переживает сессию);
// - ?debugAnalytics=0 — явно выключает и чистит localStorage;
// - параметра нет — действуем по сохранённому значению (вкл:
//   localStorage.setItem('debugAnalytics', '1'), выкл: removeItem).
// После загрузки сессией рулит только localStorage: очистка консолью
// отключает дебаг сразу и ничего не «воскрешает» его до перезагрузки страницы.
const initDebugFlag = () => {
  if (typeof window === 'undefined') return;

  const flag = new URLSearchParams(window.location.search).get(DEBUG_FLAG);

  if (flag === '1') {
    window.localStorage.setItem(DEBUG_FLAG, '1');
  } else if (flag === '0') {
    window.localStorage.removeItem(DEBUG_FLAG);
  }
};

initDebugFlag();

export const isAnalyticsDebugEnabled = () =>
  typeof window !== 'undefined' && window.localStorage.getItem(DEBUG_FLAG) === '1';

const MAX_RECENT = 20;
const recentEvents = [];
const listeners = new Set();

export const onPush = (listener) => {
  listeners.add(listener);

  return () => listeners.delete(listener);
};

export const getRecentEvents = () => recentEvents;

export const clearRecentEvents = () => {
  recentEvents.length = 0;
  listeners.forEach((listener) => listener());
};

// Единственная точка пуша в dataLayer
export const pushEvent = (event) => {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);

  recentEvents.push({ ...event, time: new Date().toLocaleTimeString() });
  if (recentEvents.length > MAX_RECENT) recentEvents.shift();

  if (isAnalyticsDebugEnabled()) {
    listeners.forEach((listener) => listener());
    console.log('%c[dataLayer]', 'color:#4bb34b;font-weight:bold', event);
  }
};

export const pushScrollEvent = (name) => {
  pushEvent({ event: 'scrollEvent', name, eventLabel: getPageUrl() });
};

export const pushButtonClick = ({ name, eventAction }) => {
  pushEvent({
    event: 'buttonClick',
    name,
    eventCategory: 'click_block',
    eventAction,
    placement: 'links',
    eventLabel: getPageUrl(),
  });
};

// ss-22080: name события = текст кнопки (подставится из children кнопки),
// eventAction = заголовок страницы инструкции
export const DOWNLOAD_EVENTS = {
  '/ios': 'Установка сертификатов МинЦифры на личные устройства iPhone и iPad',
  '/ios/harica': 'Установка сертификатов Harica на личные устройства iPhone и iPad',
  '/mac': 'Установка Сертификата на Mac OS',
  '/linux': 'Установка Сертификата на Linux',
  '/android': 'Установка сертификатов МинЦифры на личные устройства Android',
  '/android/harica': 'Установка сертификатов Harica на личные устройства Android',
  '/windows': 'Установка Сертификата на Windows',
};
